var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{attrs:{"datetime":_vm.date.formatIf(_vm.datetime, '')}},[_vm._v(_vm._s(_vm.date.formatIf(_vm.display, '-')))])
}
var staticRenderFns = []

export { render, staticRenderFns }